<template>
  <button :id="id">
    <div v-if="loading" class="text-center">
      <div class="animatedDots">
        <div class="animatedDotsChild" />
        <div class="animatedDotsItem" />
        <div class="animatedDotsInner" />
      </div>
    </div>
    <div class="button-text" v-else>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="21"
        height="21"
        fill="white"
        class="bi bi-telephone-plus"
        viewBox="0 0 16 16"
      >
        <path
          d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.6 17.6 0 0 0 4.168 6.608 17.6 17.6 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.68.68 0 0 0-.58-.122l-2.19.547a1.75 1.75 0 0 1-1.657-.459L5.482 8.062a1.75 1.75 0 0 1-.46-1.657l.548-2.19a.68.68 0 0 0-.122-.58zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877z"
        />
        <path
          fill-rule="evenodd"
          d="M12.5 1a.5.5 0 0 1 .5.5V3h1.5a.5.5 0 0 1 0 1H13v1.5a.5.5 0 0 1-1 0V4h-1.5a.5.5 0 0 1 0-1H12V1.5a.5.5 0 0 1 .5-.5"
        />
      </svg>
      <p class="text-center text-white my-auto">
        {{ t("PAYJOY_CARD_VIEWS.CALL_CX_BUTTON") }}
      </p>
    </div>
  </button>
</template>

<script setup lang="ts">
import { useI18n } from "@/apps/credit-line/composables/useI18n";

const { t } = useI18n();

defineProps<{
  id?: string;
  loading?: boolean;
}>();
</script>

<style lang="scss" scoped>
@import "@/apps/credit-line/styles/index.scss";
@import "@/assets/scss/_constants.scss";
$pj-color-alert-red: #e11d48;
button {
  background: $pj-color-green-spinner-light-content;
  border-radius: 5px;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  text-align: center;
  letter-spacing: 0px;
  color: $pj-color-white;
  width: 100%;
  border: none;
  height: 48px;
  padding: 10px 24px;
  font-family: Inter, serif;
}

.button-text {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

@keyframes bounce {
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(-10px);
  }
}
</style>
